<div class="map-view-wrapper">
  <div id="home-map"></div>

  <ng-container
    *ngIf="
      !isLoggedIn ||
      !isConfirmed ||
      showSetup ||
      ['welcome-user'].includes(authModal || '')
    "
  >
    <div class="blur-map"></div>
    <div class="map-content-wrapper">
      <div
        class="map-content"
        [ngClass]="{
          highlight: showAuthYellowBG,
          '!pb-0': authModal === 'review-cbsa-preferences'
        }"
      >
        <app-auth-modal
          *ngIf="isLoggedIn || showAuth"
          [modalWrapper]="false"
        ></app-auth-modal>
        <div *ngIf="!isLoggedIn && !showAuth">
          <app-home-welcome-guest></app-home-welcome-guest>
          <div class="pt-4 pb-6 pl-6 pr-6">
            <app-shared-button
              theme="outline"
              (click)="showAuthModal('signin')"
            >
              Sign in
            </app-shared-button>
            <div class="mt-4">
              <app-shared-button (click)="showAuthModal('signup')">
                Create account
              </app-shared-button>
            </div>
            <div class="mt-4 text-sm text-center">
              For support: Email us at
              <a href="mailto:help@rebuilt.com">{{ 'help@rebuilt.com' }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</div>
